<div class="layout-ParentDiv innerDiv UserRedemptionPage"
  [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-details-section '">
  <div class="layout-dashboard">
    <p-toast key="toastmsg"></p-toast>

    <div class="show-table-active" [ngClass]="hide ? 'show-table-active   ' : 'show-table-active  '">
      <p-toast key="toastmsg"></p-toast>

      <div class="mainDivHeader">
        <div class="leftdiv">
          <h4>User Subscripton<span class="badge">{{ totalRecords }}</span></h4>
        </div>

        <div class="rightDiv">
          <button class="exportBTn" (click)="exportExcel()"> <span><img
                src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
            Export</button>

          <!-- <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button> -->
        </div>
      </div>

      <div class="mainDivBody"> 
        <div class="date-filterDiv">
          <ul class="filtersList">
            <li>
              <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                optionLabel="label"></p-dropdown>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="FROM: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="To: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <button (click)="loadUserSubscription(lastTableLazyLoadEvent)" class="searchFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
              </button>
            </li>
            <li>
              <button (click)="clear()" class="clearFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                <span>Clear All</span>
              </button>
            </li>
          </ul> 
          <div class="divider ">
            <hr>
          </div>
           <div class="filterTitle">
            <h5>Filters</h5>
            <span class="text-danger fw-bold mb-3">Note:</span>
            <ul class="mb-3">
              <li>Please select a Country first to view available States.</li>
              <li>Please select a State first to view available Cities.</li>
            </ul>
          </div>
           <div class="maincard">
            <div class="filterList">
              <ul>
                <li>
                 <p-dropdown inputId="totalCoaches" [options]="countrylist" [filter]="true"
                    (onChange)="getStates($event)" placeholder="Select Country" optionLabel="name" appendTo="body"
                    [showClear]="true" [(ngModel)]="country"></p-dropdown>
                </li>
              
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="stateList" [filter]="true"
                    (onChange)="getCities($event)" placeholder="Select State" optionLabel="name" appendTo="body"
                    [showClear]="true" [(ngModel)]="state"></p-dropdown>
                </li>
                  <li>
                 <p-dropdown inputId="totalCoaches" [options]="cityList" [filter]="true"
                    (onChange)="loadUserSubscription(lastTableLazyLoadEvent)" placeholder="Select City"
                    optionLabel="name" optionValue="name" appendTo="body" [showClear]="true"
                    [(ngModel)]="cityName"></p-dropdown>
                </li> 
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="sportList" [filter]="true"
                    (onChange)="loadUserSubscription(lastTableLazyLoadEvent)" placeholder="Select Sport"
                    optionLabel="name" optionValue="name" appendTo="body" [showClear]="true"
                    [(ngModel)]="sportName"></p-dropdown>
                </li>
                  <li>
               <p-dropdown inputId="totalCoaches" [options]="academiesList" [filter]="true"
                    (onChange)="loadUserSubscription($event)" placeholder="Select Academy"
                    optionLabel="name" optionValue="id" appendTo="body" [showClear]="true"
                    [(ngModel)]="academyId"></p-dropdown>
                </li> 
              
              </ul>
            </div>
          </div>
           <div class="detailsList">
          <ul>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Active Subscriptions</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ userSubscriptionData?.summary?.totalActiveSubscriptions }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Active Subscriptions (Quarterly)</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ userSubscriptionData?.summary?.totalActiveSubscriptionsQuarterly }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Active Subscriptions (Half Yearly)</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ userSubscriptionData?.summary?.totalActiveSubscriptionsHalfYearly }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Active Subscriptions (Annual)</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ userSubscriptionData?.summary?.totalActiveSubscriptionsAnnual }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Revenue through Monthly Subscription</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ userSubscriptionData?.summary?.revenueThroughMonthlySubscription }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Revenue through Half Yearly Subscription</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ userSubscriptionData?.summary?.revenueThroughHalfYearlySubscription }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Revenue through Annual Subscription</h6>
                  </div>
                  <div class="mainText">
                    <h3> {{ userSubscriptionData?.summary?.revenueThroughAnnualSubscription }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Revenue</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ userSubscriptionData?.summary?.totalRevenue }}</h3>
                  </div>
              </div>
            </li> 
          </ul>
        </div> 

         
         
        </div>
        <div class="maintableDiv">
          <div class="tableParanet">
            <p-table class="expandable" #dt [value]="userSubscriptionData?.data" [autoLayout]="true" [paginator]="true" [rows]="10"
              [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
              (onLazyLoad)="loadUserSubscription($event)" [totalRecords]="totalRecords" [loading]="loading"
              [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pfrozencolumn="" class="userNameTD p-element text-nowrap" style="left: 0px"
                    pSortableColumn="academyName">
                    <div class="p-d-flex p-jc-between p-ai-center"> Mobile Number <p-sortIcon
                        field="academyName"></p-sortIcon>
                    </div>
                  </th>

                  <th pSortableColumn="fullName" class="userNameTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Username <p-sortIcon field="fullName"></p-sortIcon>
                    </div>
                  </th>
                  <th class="userNameTD" pSortableColumn="transferAmount">
                    <div class="p-d-flex p-jc-between p-ai-center"> Age <p-sortIcon
                        field="transferAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="transferCreditTD" pSortableColumn="totalCreditedAmount">
                    <div class="p-d-flex p-jc-between p-ai-center"> City <p-sortIcon
                        field="totalCreditedAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="bankName show-col"
                    [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-small '">
                    <div class="p-d-flex p-jc-between p-ai-center"> State <p-sortIcon field="bankName"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col">
                    <div class="p-d-flex p-jc-between p-ai-center"> Country <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> SubscriptionID <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Subscribed Date <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Type of Subscription <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Renewal Date <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Registered Academy <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Revenue <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> GST Amount <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy Commission % <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy Payout <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Share <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="sorting_disabled text-nowrap p-element p-frozen-column action-button-td" rowspan="1"
                    colspan="1" style="justify-content: center;">
                    <div>Action</div>
                  </th>
                </tr>

                <tr>
                  <th [ngSwitch]="academyName" pfrozencolumn="" class="userNameTD p-element text-nowrap">
                    <!-- <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyName', 'contains')"
                      [value]=" dt.filters['academyName'] ? dt.filters['academyName'].value : ''" /> -->
                  </th>

                  <th [ngSwitch]="userName" class="userNameTD p-element   text-nowrap" style="left: 0px">
                    <!-- <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
                      [value]=" dt.filters['userName'] ? dt.filters['userName'].value : ''" /> -->
                  </th>
                  <th [ngSwitch]="transferAmount" class="userNameTD p-element text-nowrap" style="left: 0px">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'transferAmount', 'contains') "
                      [value]=" dt.filters['transferAmount'] ? dt.filters['transferAmount'].value : '' " /> -->
                  </th>
                  <th [ngSwitch]="totalCreditedAmount" class="transferCreditTD p-element   text-nowrap"
                    style="left: 0px">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'totalCreditedAmount', 'contains') "
                      [value]=" dt.filters['totalCreditedAmount'] ? dt.filters['totalCreditedAmount'].value : '' " /> -->
                  </th>
                  <th [ngSwitch]="bankName " class="BankDteailsTD show-col" style="left: 0px">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'bankName', 'contains')"
                      [value]=" dt.filters['bankName'] ? dt.filters['bankName'].value : ''" /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th class="text-nowrap p-element p-frozen-column action-button-td"  style="justify-content: center;">
                    <div class="buttonColumn">
                      <button class="addBTn" (click)="addColumns()" [ngClass]="hide ? 'show-column ' : 'hide-column'">
                        + Show Column
                      </button>
                      <button class="removeBTn" (click)="removeColumns()"
                        [ngClass]="hide ? 'hide-column' : 'show-column '">
                        - Hide Column
                      </button>

                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-userSubscription>
                <tr class="p-selectable-row">
                  <td pfrozencolumn="" class="userNameTD p-element text-nowrap">
                    <div class="textOverFlow1" pTooltip="	{{userSubscription?.mobileNumber}}" tooltipPosition="bottom">
                      {{userSubscription?.mobileNumber}}
                    </div>
                  </td>
                  <td class="userNameTD">
                    {{ userSubscription?.username }}
                  </td>
                  <td class="userNameTD">
                    {{ userSubscription?.age }}
                  </td>
                  <td class="transferCreditTD">
                    {{ userSubscription?.city }}
                  </td>
                  <td class="BankDteailsTD">
                    {{ userSubscription?.state }}
                  </td>
                  <td class="BankDteailsTD">
                    {{ userSubscription?.country }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ userSubscription?.subscriptionId }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ userSubscription?.subscribedDate | date:'dd/MM/yyyy' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ userSubscription?.typeOfSubscription }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ userSubscription?.renewalDate | date:'dd/MM/yyyy' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ userSubscription?.registeredAcademy }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ userSubscription?.tplRevenue }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ userSubscription?.gstAmount }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ userSubscription?.academyCommissionPercent }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ userSubscription?.academyPayout }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ userSubscription?.tplShare }}
                  </td>
                  <td class="text-nowrap p-element p-frozen-column action-button-td">
                    
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7">User subscription list not found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
    <p-confirmDialog [style]="{ width: '400px' }" id="confirmDialog"></p-confirmDialog>
  </div>
</div>
